import React, { useEffect, useState, useCallback, useMemo } from "react";
import ReactDOM from 'react-dom';
import "../../App.css";
import {makeStyles } from "@material-ui/core/styles";
import FormaterDate from '../Formaters/FormaterDate';
//import DateEditorMask from './DateEditorMask'
import FormaterString from '../Formaters/FormaterString';
import FormaterPick from '../Formaters/FormaterPick';
import FormaterColorFact from '../Formaters/FormaterColorFact';
import FormaterColorWeek from '../Formaters/FormaterColorWeek';
import DataGrid, { SelectColumn, TextEditor, SelectCellFormatter } from 'react-data-grid';
//import { css } from '@linaria/core';
import * as R from 'ramda'
import * as api from '../../api/apiFunc' 

function EmptyRowsRenderer() {
  return (
    <div style={{ textAlign: 'center' }}>
        Нет данных
    </div>
  );
}
function createRows(data,totalrow,_columns,_PkFieldName) {
  const now = Date.now();
  let rows = [];
  if (api.isNotEmptyArr(data))
   rows = [...data, totalrow]
     else
   rows = data

    rows = rows.reduce((res, row) => {
    let rowKeys = R.keys(row);
    let yy = 0   
    rowKeys.map(n=>{
      let col = R.find(R.propEq('key', n))(_columns)
      if (!api.isEmpty(col)) {
        if (col._type === 1) {
          if (!row['isTotalRow']) {
            if (typeof row[n] == "string" && row[n].indexOf('$') == -1) {
              row[n] = row['datan'] + '#' + row['planh'] + '$' + row[n]
            }
            else {
              if (!(row[n] && row[n].toString().indexOf('$') !== -1)) {
                if (row[_PkFieldName])
                  row[n] = row['datan'] + '#' + row['planh'] + '#0' + '$' + row[n]
                else
                  row[n] = `${yy}$-`
              }
            }
          }
          else {
            if (typeof row[n] == "string" && row[n].indexOf('$') == -1) {
              row[n] =  "0#"+ row['planh'] + '#1' + '$' + row[n]
            }
            else {
              if (!(row[n] && row[n].toString().indexOf('$') !== -1)) {
                  row[n] = "0#"+row['planh']+ '#1' + '$' + row[n]
              }
            }
           }
        }
      }
    })
    yy++
    return [...res, row]
  },[])

  return rows;
}
function rowKeyGetter(row) {
  return row.id;
}
/*
function SelectEditor(p) {
  return (
        <input
            autoFocus
            type="range"
            min="0"
            max="100"
            value={row.progress}
            onChange={(e) => onRowChange({ ...p.row, progress: e.target.valueAsNumber })}
          />

    <select
      autoFocus
      className={textEditorClassname}
      value={p.row.country}
      onChange={(e) => p.onRowChange({ ...p.row, country: e.target.value }, true)}
    >
      {countries.map((country) => (
        <option key={country}>{country}</option>
      ))}
    </select>
  )
}
*/
const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    textAlign: "left",
    backgroundColor: "#3f51b5",
    height: "40px",
    width: "100%"
  },
  content: {
    paddingLeft: theme.spacing.unit * 3
  },
}));
const ShowGrid = props => {
  const classes = useStyles();
  const { data,totalrow, PrimaryId, myfiolist, columnsgrid } = props;
  //const [rows, setRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState(() => new Set());
  const [currow, Setcurrow] = useState(0);
 /* useEffect(() => {
    if (api.isNotEmptyArr(data))
       setRows(data);
  }, [data]);
  useEffect(() => {
    console.log('rows ==',rows);
  }, [rows]); */
  useEffect(() => {
    let node = document.getElementById("datagrid");
    let canvas = ReactDOM.findDOMNode(node);
    canvas.addEventListener('keydown', keyListenerDown);
    canvas.addEventListener('keyup', keyListenerUp);
    return () => {
      canvas.removeEventListener('keydown', keyListenerDown);
      canvas.removeEventListener('keyup', keyListenerUp);
    };
  }); 
 
  const keyListenerDown = (e) => {
    if (e.key ===  "ArrowDown")
    {
      e.preventDefault();
      Setcurrow(currow + 1)
      //console.log('currow = ', currow + 1);
      props.onCurRow(_rows[currow+1])
    }
   };

   const keyListenerUp = (e) => {
    if (e.key ===  "ArrowUp")
    {
      e.preventDefault();
      Setcurrow(currow - 1)
      //console.log('currow = ', currow-1);
      props.onCurRow(_rows[currow-1])
    }
   };

 const summaryRows = useMemo(() => {
    const summaryRow = totalrow
    return [summaryRow];
  }, [totalrow]);

 //if (!api.isNotEmptyArr(data))
 //   return null

  let _rows,_columns,_PkFieldName;
   _rows=data
   _columns = columnsgrid
   _PkFieldName = PrimaryId

   if (api.isNotEmptyArr(data))
   //  _rows = [...data, totalrow]
   //else
    _rows = data  
  
    let yy = 0

  _columns.map((data)=>{
     switch(data['key']) {
      case 'DIRECTIONCODE': case 'DIRECTIONNAME': case 'DIRECTIONNAMEEN':
         data.editor = TextEditor 
         //data.editorOptions= {editOnClick: true}
        break 
    }
     
  })
  let name_columns = _columns.map(elem=>elem.key)
  let filteredRows = _rows

  const rowsChange = (rows,change ) => {
    //console.log('rowsChangeData=', change);
    //column: {key: 'd06', name: '6', resizable: false, editable: true, width: 50, …}
    //indexes: [0]
    /*if (rows[change.indexes[0]].category_id == 6) 
    {
      props.onHandleMess("Для этой колонки корректировка запрещена !") 
      return
    }*/
      let val=rows[change.indexes[0]][change.column.key]
      const currow = rows[change.indexes[0]] 
   // if (!isNaN(parseFloat(val)) && !isNaN(val - 0)) {
      //console.log('n==', Number(n));
   //   val = Number(val).toFixed(2)
      const updcol = change.column.key
      rows[change.indexes[0]][updcol] = val
      if (updcol == 'DIRECTIONCODE' && R.findIndex(R.propEq('DIRECTIONCODE', Number(val)))(_rows) != -1) {
        props.onMessage("Запись с таким кодом уже введена!") 
        return 
      } 
      const updrow = { [_PkFieldName]: rows[change.indexes[0]][_PkFieldName], updated: { [updcol]: val } }
      props.onHandleUpdateGrid(rows,currow,updrow) 
  }
  const onRowClick = (row, column) => {
    let row_idx = R.findIndex(R.propEq('ID', row.ID))(_rows);
    Setcurrow(row_idx)
    //props.onCurRow(_rows[rowIdx], _rows.length) 
    props.onCurRow(_rows[row_idx]) 
  }
   
 const rowGetter = rowNumber => {
    let curRow = {...filteredRows[rowNumber]}
    return curRow
 }
  return (
    <DataGrid
        style={{minHeight:props.minHeight}}
        rowKeyGetter={rowKeyGetter}
        columns={_columns}
        rows={_rows}
        defaultColumnOptions={{
          sortable: true,
          resizable: true
        }} 
        onRowClick={onRowClick}
        selectedRows={selectedRows}
         onRowsChange={rowsChange}
         noRowsFallback={<EmptyRowsRenderer />}
        //rowHeight={30}
        //minHeight={props.minHeight || 250}
        /*onSelectedRowsChange={setSelectedRows}
        sortColumns={sortColumns}
        onSortColumnsChange={setSortColumns}*/
        //summaryRows={summaryRows}
        className="fill-grid"
      />
   );
}
export default ShowGrid
